module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aGDpO"))).then(() => parcelRequire('d0iPb'));